import type { SpeedMode } from "./SpeedMode";

/** The clock surface a `PresentationTaskRunner` reads. `PresentationClock` (speed-mode driven) and
 *  `FixedPresentationClock` (constant) both satisfy it. */
export interface PresentationClockPort {
  /** Finite and above 0 (1 = normal speed). */
  getTimeScale(): number;
  scaleDurationSeconds(seconds: number): number;
  getMode(): SpeedMode;
}

/**
 * A clock that never speed-scales — the runner for UI CHROME (panel enter/exit, hint fades, HUD
 * pulses). They share the runner API and still
 * pause / frame-step with the presentation ticker, but turbo never shortens them.
 */
export class FixedPresentationClock implements PresentationClockPort {
  public constructor(private readonly scale: number = 1) {
    if (!Number.isFinite(scale) || scale <= 0) throw new Error(`FixedPresentationClock: the scale must be finite and above 0, got ${scale}`);
  }

  public getTimeScale(): number {
    return this.scale;
  }

  public scaleDurationSeconds(seconds: number): number {
    return seconds / this.scale;
  }

  public getMode(): SpeedMode {
    return "normal";
  }
}
